var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import PropTypes from 'prop-types';
import { decl } from '@yandex-lego/i-bem-react';

export default decl({
    block: 'tumbler',
    elem: 'text',
    tag: 'span',
    mods: function mods(_ref) {
        var side = _ref.side;

        return { side: side };
    },
    attrs: function attrs(_ref2) {
        var id = _ref2.id;

        return _extends({}, this.__base.apply(this, arguments), {
            'aria-hidden': 'true',
            id: id
        });
    }
}, {
    propTypes: {
        id: PropTypes.string
    }
});